module.exports = __webpack_public_path__ + "media/images/covers/starworks-weekly-sept24-bg-811a61ad412ebf9717af86f7a07abfb3.png";